import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getAgentInventories = createAsyncThunk(
  "agentInventory/getAgentInventories",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/inventory/agent/${data.id}?type=${data.type?data.type:""}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

